<template>
    <nav class="navbar default-layout-navbar logistics-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div class="navbar-menu-wrapper logistics-navbar__menu d-flex align-items-stretch">
            <a href="" class="align-self-center d-lg-none pl-0 navbar-brand">
                <!-- <img :src="logoUrl" alt="logo"/> -->
            </a>
            <div class="logistics-navbar__layout d-flex justify-content-between align-items-center w-100">
                <div class="logistics-navbar__section logistics-navbar__section--left d-flex justify-content-start align-items-center">
                    <button class="navbar-toggler align-self-center d-none d-lg-block pl-0 logistics-navbar__control logistics-navbar__control--sidebar"
                            type="button">
                <span v-if="leftMenuType === 'normal'"
                      :key="'align-left'"
                      @click.prevent="togglingLeftMenu('active-icon-only-menu')"
                      :title="$t('collapse_sidebar')">
                    <app-icon :name="'align-left'"/>
                </span>
                        <span v-else-if="leftMenuType === 'icon-only'"
                              :key="'align-center'"
                              @click.prevent="togglingLeftMenu('active-floating-menu')"
                              :title="$t('floating_sidebar')">
                    <app-icon :name="'align-center'"/>
                </span>
                        <span v-else-if="leftMenuType === 'floating'"
                              :key="'align-justify'"
                              @click.prevent="togglingLeftMenu('active-normal-menu')"
                              :title="$t('full_sidebar')">
                    <app-icon :name="'align-justify'"/>
                </span>
                    </button>
                    <button class="navbar-toggler align-self-center d-lg-none pl-0 logistics-navbar__control logistics-navbar__control--sidebar"
                            type="button"
                            data-toggle="offcanvas"
                            @click="sidebarOffcanvas">
                        <app-icon :name="'align-left'"/>
                    </button>
                    <!-- <div class="navbar-command-strip d-none d-xl-flex">
                        <span class="navbar-command-strip__signal"></span>
                        <div class="navbar-command-strip__copy">
                            <span class="navbar-command-strip__eyebrow">{{ companyName }}</span>
                            <strong>{{ applicationName }}</strong>
                        </div>
                        <span class="navbar-command-strip__status">{{ $t('live_operations') }}</span>
                    </div> -->
                    <slot name="left-option"></slot>
                </div>
                <div class="logistics-navbar__section logistics-navbar__section--center d-flex justify-content-center">
                    <slot name="center-option"></slot>
                </div>
                <div class="logistics-navbar__section logistics-navbar__section--right">
                    <ul class="navbar-nav navbar-nav-right ml-auto logistics-navbar__actions">
                        <li class="nav-item logistics-client-scope" v-if="showClientScopeSelector">
                            <div class="logistics-client-scope__control">
                                <span class="logistics-client-scope__label">{{ $t('client_scope') }}</span>
                                <select class="logistics-client-scope__select"
                                        :value="selectedClientScopeValue"
                                        @change="handleClientScopeChange">
                                    <option value="">{{ $t('all_authorized_clients') }}</option>
                                    <option v-for="client in authorizedClientOptions"
                                            :key="client.id"
                                            :value="client.id">
                                        {{ client.name }}
                                    </option>
                                </select>
                            </div>
                        </li>
                        <li class="nav-item" v-if="showMood">
                            <button class="navbar-toggler align-self-center logistics-navbar__control logistics-navbar__control--mode"
                                    :class="{ 'is-dark': darkMode }"
                                    type="button"
                                    @click.prevent="toggleDarkMode">
                            <span v-if="darkMode" :key="'sun'" :title="$t('light_mood')">
                                <app-icon :name="'sun'"/>
                            </span>
                                            <span v-else :key="'moon'" :title="$t('dark_mood')">
                                <app-icon :name="'moon'"/>
                            </span>
                            </button>
                        </li>
                        <li class="nav-item dropdown logistics-theme-picker">
                            <a class="d-flex align-items-center nav-link logistics-theme-picker__toggle logistics-navbar__control logistics-navbar__control--theme"
                               href="#"
                               data-toggle="dropdown"
                               data-display="static"
                               aria-haspopup="true"
                               aria-expanded="false"
                               :title="$t('brand_theme')"
                               @click.prevent>
                                <span class="logistics-theme-picker__current"
                                      :style="{ background: `linear-gradient(135deg, ${currentBrandTheme.primary}, ${currentBrandTheme.gradientEnd})` }"></span>
                                <app-icon :name="'palette'"/>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right logistics-theme-picker__menu">
                                <div class="logistics-theme-picker__menu-header">
                                    <span>{{ $t('brand_theme') }}</span>
                                    <small>{{ $t('choose_brand_theme') }}</small>
                                </div>
                                <button v-for="theme in brandThemeOptions"
                                        :key="theme.key"
                                        type="button"
                                        class="dropdown-item logistics-theme-picker__option"
                                        :class="{ 'is-active': activeBrandTheme === theme.key }"
                                        :aria-pressed="activeBrandTheme === theme.key ? 'true' : 'false'"
                                        @click.prevent="setBrandTheme(theme.key)">
                                    <span class="logistics-theme-picker__swatch"
                                          :style="{ background: `linear-gradient(135deg, ${theme.primary}, ${theme.gradientEnd})` }"></span>
                                    <span class="logistics-theme-picker__option-copy">
                                        <strong>{{ theme.label }}</strong>
                                        <small>{{ theme.primary }}</small>
                                    </span>
                                    <span class="logistics-theme-picker__check"
                                          :class="{ 'is-active': activeBrandTheme === theme.key }">
                                        <app-icon v-if="activeBrandTheme === theme.key" :name="'check'"/>
                                    </span>
                                </button>
                            </div>
                        </li>
                        <li class="nav-item d-none d-lg-block">
                            <a v-if="fullScreen" class="d-flex align-items-center nav-link logistics-navbar__control logistics-navbar__control--fullscreen" href="#" :key="'maximize'"
                               @click="fullscreen" :title="$t('exit_fullscreen')">
                                <app-icon :name="'minimize'"/>
                            </a>
                            <a v-else class="d-flex align-items-center nav-link logistics-navbar__control logistics-navbar__control--fullscreen" href="#" :key="'minimize'"
                               @click="fullscreen"
                               :title="$t('fullscreen')">
                                <app-icon :name="'maximize'"/>
                            </a>
                        </li>

                        <app-navbar-language-dropdown
                            :selected-language="selectedLanguage"
                            :data="languageData"
                        />

                        <!-- <component
                            :is="notificationComponent"
                            :all-notification-url="allNotificationUrl"
                            :data="notificationData"
                            :show-identifier="showIdentifier"
                            :total-unread="totalUnread"
                            @clicked="sendNotification"
                            @loadNotifications="$emit('loadNotifications')"
                        /> -->

                        <span class="topbar-divider d-none d-sm-block"/>

                        <app-navbar-profile-dropdown
                            :user="user"
                            :data="profileData"
                        />
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import ThemeMixin from "../../mixins/global/ThemeMixin"
import CoreLibrary from "../../helpers/CoreLibrary";
import AppFunction from "../../helpers/app/AppFunction";
import { selectClientScope } from "../../helpers/app/ClientScope";
// import { urlGenerator } from '../../../app/Helpers/AxiosHelper';

export default {
    name: "Navbar",
    mixins: [ThemeMixin],
    extends: CoreLibrary,
    props: {
        user: {
            type: Object,
            require: true
        },
        profileData: {
            type: Array,
            require: true
        },
        selectedLanguage: {
            type: String,
            default: 'EN'
        },
        languageData: {
            type: Array,
            require: true
        },
        notificationData: {
            type: Array,
            require: true
        },
        logoUrl: {
            type: String,
            default: AppFunction.getAppUrl('images/core.png'),
        },
        allNotificationUrl: {
            type: String,
            require: true
        },
        showIdentifier: {
            type: Boolean,
            default: false
        },
        showMood: {
            type: Boolean,
            default: false
        },
        totalUnread: {
            type: Number
        },
        notificationComponent: {
            type: String,
            default: 'app-navbar-notification-dropdown'
        }

    },
    computed: {
        companyName() {
            return this.$store.state.settings.appSettings?.brand_name || 'BRAS SECURITY';
        },
        authorizedClientOptions() {
            return this.$store.state.clientScope?.authorizedClients || [];
        },
        applicationName() {
            return this.$store.state.settings.appSettings?.app_name || 'Escort System';
        },
        selectedClientScopeValue() {
            const selectedClientId = this.$store.state.clientScope?.selectedClientId;

            return selectedClientId ? String(selectedClientId) : '';
        },
        showClientScopeSelector() {
            return Boolean(this.$store.state.clientScope?.isClientScoped)
                && this.authorizedClientOptions.length > 1;
        }
    },
    data() {
        return {
            fullScreen: false,
            leftMenuType: 'normal',
        }
    },
    watch: {
        leftMenuType: function () {
            let htmlElement = document.documentElement;

            if (this.leftMenuType === 'normal') {
                localStorage.setItem('sidebar', 'normal');
                htmlElement.setAttribute('sidebar', 'normal');
            } else if (this.leftMenuType === 'icon-only') {
                localStorage.setItem('sidebar', 'icon-only');
                htmlElement.setAttribute('sidebar', 'icon-only');
            } else {
                localStorage.setItem('sidebar', 'floating');
                htmlElement.setAttribute('sidebar', 'floating');
            }
        }
    },
    mounted() {
        let body = $('body'),
            htmlElement = document.documentElement,
            sidebar = localStorage.getItem('sidebar');

        if (sidebar === 'normal') {
            localStorage.setItem("sidebar", 'normal');
            htmlElement.setAttribute('sidebar', 'normal');
            body.removeClass('sidebar-icon-only');
            body.removeClass('sidebar-hover-only');
            this.leftMenuType = 'normal';
        } else if (sidebar === 'icon-only') {
            localStorage.setItem("sidebar", 'icon-only');
            htmlElement.setAttribute('sidebar', 'icon-only');
            body.removeClass('sidebar-hover-only');
            body.toggleClass('sidebar-icon-only');
            this.leftMenuType = 'icon-only';
        } else if (sidebar === 'floating') {
            localStorage.setItem("sidebar", 'floating');
            htmlElement.setAttribute('sidebar', 'floating');
            body.removeClass('sidebar-icon-only');
            body.toggleClass('sidebar-hover-only');
            $('.sidebar').find('.collapse.show').collapse('hide');
            this.leftMenuType = 'floating';
        }
    },
    methods: {
        sendNotification(notification) {
            this.$emit('clicked', notification);
        },
        sidebarOffcanvas() {
            $('.sidebar-offcanvas').toggleClass('active')
        },
        fullscreen() {
            if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                    document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                    document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                } else if (document.documentElement.msRequestFullscreen) {
                    document.documentElement.msRequestFullscreen();
                }
                this.fullScreen = true;
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                this.fullScreen = false;
            }
        },
        togglingLeftMenu(action) {
            let body = $('body');

            if (action === 'active-icon-only-menu') {
                body.removeClass('sidebar-hover-only');
                body.toggleClass('sidebar-icon-only');
                this.leftMenuType = 'icon-only';
            } else if (action === 'active-floating-menu') {
                body.removeClass('sidebar-icon-only');
                body.toggleClass('sidebar-hover-only');
                $('.sidebar').find('.collapse.show').collapse('hide');
                this.leftMenuType = 'floating';
            } else if (action === 'active-normal-menu') {
                body.removeClass('sidebar-icon-only');
                body.removeClass('sidebar-hover-only');
                this.leftMenuType = 'normal';
            }
        },
        handleClientScopeChange(event) {
            const selectedClientId = selectClientScope(
                event.target.value,
                this.authorizedClientOptions,
                this.$store
            );

            this.$store.commit('SET_CLIENT_SCOPE_CONTEXT', {
                isClientScoped: this.$store.state.clientScope?.isClientScoped,
                authorizedClients: this.authorizedClientOptions,
                selectedClientId,
            });

            window.location.reload();
        }
    }
}
</script>

<style scoped>
.logistics-client-scope {
    display: flex;
    align-items: center;
    margin-right: 0.75rem;
}

.logistics-client-scope__control {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    padding: 0.4rem 0.75rem;
    border: 1px solid rgba(148, 163, 184, 0.28);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.92);
}

.logistics-client-scope__label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #64748b;
    white-space: nowrap;
}

.logistics-client-scope__select {
    min-width: 10.5rem;
    border: 0;
    background: transparent;
    color: #0f172a;
    font-size: 0.92rem;
    font-weight: 600;
    padding-right: 0.25rem;
    outline: none;
}

[theme='dark'] .logistics-client-scope__control {
    background: rgba(15, 23, 42, 0.82);
    border-color: rgba(148, 163, 184, 0.2);
}

[theme='dark'] .logistics-client-scope__label {
    color: #94a3b8;
}

[theme='dark'] .logistics-client-scope__select {
    color: #e2e8f0;
}

@media (max-width: 1199.98px) {
    .logistics-client-scope__label {
        display: none;
    }

    .logistics-client-scope__control {
        padding-left: 0.65rem;
        padding-right: 0.65rem;
    }

    .logistics-client-scope__select {
        min-width: 8.25rem;
    }
}
</style>
